export interface Category {
  slug: string
  name: string
  description: string
  icon: string
  articleCount: number
}

export const categories: Category[] = [
  {
    slug: 'core-philosophy',
    name: '核心理念',
    description: '探索秘密教学最根本的思想体系与认知框架，揭示隐藏知识传承的底层逻辑与哲学根基。',
    icon: 'ri-lightbulb-line',
    articleCount: 8,
  },
  {
    slug: 'practice-methods',
    name: '实践方法',
    description: '将秘密教学理论转化为可操作的学习实践，提供具体的方法论指导与行动路径。',
    icon: 'ri-tools-line',
    articleCount: 10,
  },
  {
    slug: 'application-scenarios',
    name: '应用场景',
    description: '秘密教学在不同领域中的实际应用案例，展示隐秘知识如何解决真实世界的问题。',
    icon: 'ri-global-line',
    articleCount: 7,
  },
  {
    slug: 'mind-training',
    name: '思维训练',
    description: '高阶认知训练方法与心智模型构建，帮助你突破思维定式、提升认知层级。',
    icon: 'ri-brain-line',
    articleCount: 9,
  },
  {
    slug: 'case-studies',
    name: '案例分析',
    description: '深度剖析真实案例中的秘密教学实践，从他人的经验中汲取智慧与启发。',
    icon: 'ri-file-search-line',
    articleCount: 6,
  },
]